<template>
  <div>
    <h4>Modifier votre publication</h4>
    <div class="my-3">
      <div>{{ commentToEdit.pub.user.nickname }}</div>
      <small class="text-muted"
        >{{ commentToEdit.pub.created_at | formatDateTime }}
      </small>
    </div>
    <template v-if="commentToEdit.pub.flagged">
      <b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
      <small>
        Votre publication est actuellement masqué pour tous. Veuillez svp la
        modifier tout en respectant les règles de Dlibr.</small
      >
    </template>

    <hr />
    <CommentForm @postSucceded="onPostSucceded" @postFailed="onPostFailed" />
  </div>
</template>

<script>
/**
 * @file       Comment modify component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { commentsMixin } from "@/modules/comments/mixins";
import CommentForm from "@/modules/comments/components/form.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "modifyComment",
  mixins: [commentsMixin],
  components: {
    CommentForm
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Called on post comment succeeded.
     */
    onPostSucceded() {
      this.$root.$emit("bv::toggle::collapse", "property-panel");
    },

    /**
     * Called on post comment failed.
     */
    onPostFailed() {
      this.$root.$emit("bv::toggle::collapse", "property-panel");
    }
  }
};
</script>

<style lang="scss" scoped></style>
